<div class="right-side p-5">
  <div class="section">
    <form [formGroup]="form" class="w-100">
      <div class="card mb-3">
        <div class="card-header"> <h2>Grievance Details by MSME</h2></div>
        <div class="card-body">
          <div class="row">
            <mat-label>Grievance ID : </mat-label>
            <mat-form-field appearance="outline" class="w-100">
              <input matInput formControlName="msmeGrievanceId">
            </mat-form-field>
          </div>
          <div class="row">
            <mat-label>Grievance Type : </mat-label>
            <mat-form-field appearance="outline" class="w-100">
              <input matInput formControlName="grievanceName">
            </mat-form-field>
          </div>
          <div class="row">
            <mat-label>Subject : </mat-label>
            <mat-form-field appearance="outline" class="w-100">
              <input matInput formControlName="subject">
            </mat-form-field>
          </div>
          <div class="row">
            <mat-label>Description : </mat-label>
            <mat-form-field appearance="outline" class="w-100">
              <input matInput formControlName="description">
            </mat-form-field>
          </div>
          <div class="row">
            <mat-label>Greivance Raised Date : </mat-label>
            <mat-form-field appearance="outline" class="w-100">
              <input matInput formControlName="createdDate">
            </mat-form-field>
          </div>
          <div class="row" *ngIf="showDownloadBtnMSME">
            <div class="col-md-3">
              <mat-label>Document attached by MSME : </mat-label>
              <mat-card-content>
                <a style="cursor: pointer" class="btn btn-warning btn-sm mt-1"
                   (click)="onDownload()">
                  <i class="bi bi-download"></i> Download
                </a>
                <button class="btn btn-primary btn-sm mx-2 mt-1" (click)="openFilePreviewDialog()"><i class="bi bi-eye"></i> View File</button>

              </mat-card-content>
            </div>
          </div>
        </div>
      </div>

      <div class="card mb-3">
        <div class="card-header"> <h2>Grievance Resolution by Reviewer</h2></div>
        <div class="card-body">
          <div class="row">
            <mat-label>Reply : </mat-label>
            <mat-form-field appearance="outline" class="w-100">
              <input matInput formControlName="reply">
            </mat-form-field>
          </div>
          <div class="row" *ngIf="showDownloadBtn">
            <div class="col-md-3">
              <mat-label>Document attached by Reviewer : </mat-label>
              <mat-card-content>
                <a style="cursor: pointer" class="btn btn-warning btn-sm"
                   (click)="onReplyDownload()">
                  <i class="bi bi-download"></i> Download
                </a>
                <button class="btn btn-primary btn-sm mx-2 mt-1" (click)="openReplyFilePreviewDialog()"><i class="bi bi-eye"></i> View File</button>
              </mat-card-content>
            </div>
          </div>
          <div class="row">
            <mat-label>Status : </mat-label>
            <mat-form-field appearance="outline" class="w-100">
              <input matInput formControlName="status">
            </mat-form-field>
          </div>
        </div>
      </div>
      <button (click)="Reset()" class="btn btn-info">Back</button>
    </form>
  </div>
</div>



